(function() {
  'use strict';

  var bar = document.querySelector('[data-sticky-add-to-cart]');
  if (!bar) return;

  var productData = parseJson(bar.querySelector('[data-sticky-product-json]')) || {};
  var variants = {};
  (productData.variants || []).forEach(function(variant) {
    variants[Number(variant.id)] = {
      id: Number(variant.id),
      available: Boolean(variant.available),
      price: Number(variant.price) || 0,
      comparePrice: Number(variant.compare_at_price) || 0,
      title: variant.title || '',
      image: getImageUrl(variant.featured_image)
    };
  });

  var currentVariantId = Number(productData.currentVariantId) || null;
  var bundleSettings = getBundleSettings(productData.productId);
  var hasBundle = Boolean(bundleSettings && bundleSettings.dealBars && bundleSettings.dealBars.some(function(deal) {
    return deal.dealBarType === 'bundle' || Number(deal.quantity) > 1;
  }));
  var bundleRoot = null;
  var mode = 'normal';
  var loading = false;
  var frame = null;
  var bundleObserver = null;
  var discoveryObserver = null;
  var feedbackTimer = null;

  var elements = {
    title: bar.querySelector('[data-sticky-title]'),
    price: bar.querySelector('[data-sticky-price]'),
    comparePrice: bar.querySelector('[data-sticky-compare-price]'),
    context: bar.querySelector('[data-sticky-context]'),
    image: bar.querySelector('[data-sticky-image]'),
    button: bar.querySelector('[data-sticky-add-btn]'),
    buttonText: bar.querySelector('[data-sticky-btn-text]'),
    loader: bar.querySelector('[data-sticky-btn-loader]'),
    check: bar.querySelector('[data-sticky-btn-check]')
  };

  var text = {
    add: bar.dataset.addToCartText || 'Add to cart',
    soldOut: bar.dataset.soldOutText || 'Sold out',
    offer: bar.dataset.bundleOfferText || 'Bundle savings available',
    viewBundle: bar.dataset.viewBundleText || 'View bundle',
    selectBundle: bar.dataset.selectBundleText || 'Select bundle',
    addBundle: bar.dataset.addBundleText || 'Add bundle'
  };

  elements.button.addEventListener('click', onButtonClick);
  document.addEventListener('variant:change', onVariantChange);
  document.addEventListener('ajaxProduct:added', onAddSuccess);
  document.addEventListener('ajaxProduct:error', onAddError);
  document.addEventListener('product-form:submit:success', onAddSuccess);
  document.addEventListener('product-form:submit:error', onAddError);
  window.addEventListener('scroll', scheduleRender, { passive: true });
  window.addEventListener('resize', scheduleRender);

  if (hasBundle) {
    renderGuide();
    findBundle();
    if (!bundleRoot && window.MutationObserver) {
      discoveryObserver = new MutationObserver(findBundle);
      discoveryObserver.observe(document.body, { childList: true, subtree: true });
    }
  } else {
    renderNormal();
  }

  show();

  function parseJson(element) {
    if (!element) return null;
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.warn('[StickyAddToCart] Invalid JSON', error);
      return null;
    }
  }

  function getImageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  }

  function getBundleSettings(productId) {
    var selector = '.kaching-bundles-deal-block-settings';
    if (productId) selector += '[data-product-id="' + productId + '"]';
    return parseJson(document.querySelector(selector));
  }

  function findBundle() {
    var productSelector = productData.productId
      ? 'kaching-bundle[product-id="' + productData.productId + '"]'
      : 'kaching-bundle';
    var root = document.querySelector(productSelector);
    var bars = document.querySelector('.kaching-bundles__bars');

    if (!root && bars) root = bars.closest('kaching-bundle') || bars;
    if (!root || !root.querySelector('.kaching-bundles__bars')) return;

    bundleRoot = root;
    if (discoveryObserver) discoveryObserver.disconnect();
    if (window.MutationObserver) {
      bundleObserver = new MutationObserver(scheduleRender);
      bundleObserver.observe(bundleRoot, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
        attributeFilter: ['class', 'disabled']
      });
    }
    scheduleRender();
  }

  function scheduleRender() {
    if (frame) return;
    frame = requestAnimationFrame(function() {
      frame = null;
      render();
    });
  }

  function render() {
    if (!hasBundle) {
      renderNormal();
      show();
      return;
    }
    if (!bundleRoot) {
      renderGuide();
      show();
      return;
    }

    var rect = bundleRoot.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top < viewportHeight && rect.bottom > 0) {
      hide();
    } else {
      rect.bottom <= 0 ? renderSelection() : renderGuide();
      show();
    }
  }

  function renderGuide() {
    mode = 'guide';
    bar.classList.add('is-guide');
    var variant = getCurrentVariant();
    setImage(variant);
    setSummary(productData.productTitle, variant ? formatMoney(variant.price) : '', '', text.offer);
    setButton(text.viewBundle, false);
  }

  function renderNormal() {
    mode = 'buy';
    bar.classList.remove('is-guide');
    var variant = getCurrentVariant();
    if (!variant) {
      setSummary(productData.productTitle, '', '', '');
      setButton(text.add, false);
      return;
    }

    setImage(variant);
    setSummary(
      getVariantTitle(variant),
      formatMoney(variant.price),
      variant.comparePrice > variant.price ? formatMoney(variant.comparePrice) : '',
      ''
    );
    setButton(variant.available ? text.add : text.soldOut, !variant.available);
  }

  function renderSelection() {
    bar.classList.remove('is-guide');
    var selected = bundleRoot.querySelector('.kaching-bundles__bar--selected');
    if (!selected) {
      mode = 'select';
      setSummary(productData.productTitle, '', '', text.offer);
      setButton(text.selectBundle, false);
      return;
    }

    var deal = findDeal(selected.dataset.dealBarId);
    var isBundle = deal && deal.dealBarType === 'bundle';
    var priceElement = selected.querySelector('.kaching-bundles__bar-price');
    var compareElement = selected.querySelector('.kaching-bundles__bar-full-price');
    var titleElement = selected.querySelector('.kaching-bundles__bar-title');
    var variant = getCurrentVariant();
    var count = getItemCount(deal);
    var nativeButton = findNativeButton();
    var unavailable = Boolean(nativeButton && nativeButton.disabled);

    mode = 'buy';
    setImage(variant);
    setSummary(
      isBundle && titleElement ? titleElement.textContent.trim() : getVariantTitle(variant),
      priceElement ? priceElement.textContent.trim() : (variant ? formatMoney(variant.price) : ''),
      compareElement ? compareElement.textContent.trim() : '',
      count ? count + (count === 1 ? ' item' : ' items') : ''
    );
    setButton(unavailable ? text.soldOut : (isBundle ? text.addBundle : text.add), unavailable);
  }

  function getCurrentVariant() {
    return variants[currentVariantId] || null;
  }

  function getVariantTitle(variant) {
    if (!variant || !variant.title || variant.title === 'Default Title') return productData.productTitle;
    return productData.productTitle + ' - ' + variant.title;
  }

  function findDeal(id) {
    var deals = bundleSettings && bundleSettings.dealBars || [];
    return deals.filter(function(deal) { return String(deal.id) === String(id); })[0] || null;
  }

  function getItemCount(deal) {
    if (!deal) return 0;
    if (deal.dealBarType === 'bundle' && Array.isArray(deal.bundleProducts)) {
      return deal.bundleProducts.reduce(function(total, item) {
        return total + (Number(item.quantity) || 0);
      }, 0);
    }
    return Number(deal.quantity) || 1;
  }

  function setSummary(title, price, comparePrice, context) {
    elements.title.textContent = title || productData.productTitle || '';
    elements.price.textContent = price || '';
    toggleText(elements.comparePrice, comparePrice);
    toggleText(elements.context, context);
  }

  function toggleText(element, value) {
    element.textContent = value || '';
    element.classList.toggle('hide', !value);
  }

  function setImage(variant) {
    if (!elements.image) return;
    var source = variant && variant.image || productData.defaultImage;
    if (source) elements.image.src = source;
  }

  function setButton(label, disabled) {
    elements.buttonText.textContent = label;
    elements.button.setAttribute('aria-label', label);
    elements.button.disabled = Boolean(disabled || loading);
    if (!loading) resetFeedback();
  }

  function onButtonClick() {
    if (loading) return;
    if (mode === 'guide' || mode === 'select') {
      scrollToBundle();
      return;
    }

    var nativeButton = findNativeButton();
    if (!nativeButton || nativeButton.disabled) return;
    var nativeForm = nativeButton.closest('form');
    if (!nativeForm) return;
    startLoading();
    if (typeof nativeForm.requestSubmit === 'function') {
      nativeForm.requestSubmit(nativeButton);
    } else {
      nativeForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  function findNativeButton() {
    return document.querySelector('[data-pm-add-cart], [data-add-to-cart]');
  }

  function scrollToBundle() {
    if (!bundleRoot) return;
    bundleRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(function() {
      var target = bundleRoot.querySelector('.kaching-bundles__block-title, .kaching-bundles__bar-main');
      if (!target) return;
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }, 400);
  }

  function onVariantChange(event) {
    var detail = event.detail || {};
    var variant = detail.variant || detail;
    var id = Number(variant.id || variant);
    if (!id) return;
    currentVariantId = id;
    scheduleRender();
  }

  function startLoading() {
    loading = true;
    elements.button.disabled = true;
    elements.button.classList.add('is-loading');
    elements.button.setAttribute('aria-busy', 'true');
    elements.buttonText.classList.add('hide');
    elements.loader.classList.remove('hide');
    feedbackTimer = setTimeout(onAddError, 12000);
  }

  function onAddSuccess() {
    if (!loading) return;
    clearTimeout(feedbackTimer);
    loading = false;
    elements.button.classList.remove('is-loading');
    elements.button.classList.add('is-added');
    elements.button.setAttribute('aria-busy', 'false');
    elements.loader.classList.add('hide');
    elements.check.classList.remove('hide');
    feedbackTimer = setTimeout(function() {
      resetFeedback();
      scheduleRender();
    }, 1500);
  }

  function onAddError() {
    if (!loading) return;
    clearTimeout(feedbackTimer);
    loading = false;
    resetFeedback();
    scheduleRender();
  }

  function resetFeedback() {
    elements.button.classList.remove('is-loading', 'is-added');
    elements.button.setAttribute('aria-busy', 'false');
    elements.buttonText.classList.remove('hide');
    elements.loader.classList.add('hide');
    elements.check.classList.add('hide');
  }

  function show() {
    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');
  }

  function hide() {
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents, productData.moneyFormat);
    }
    return (productData.moneyFormat || '${{amount}}').replace('{{amount}}', (cents / 100).toFixed(2));
  }
})();
